import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { BANKING_DETAILS } from '../../../routes/routes';
import './Address.css';

class Address extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    handleRedirect(nextPage: string) {
        this.props.redirectTo(nextPage);
    }

    public render() {
      
        return (
            <div>
                <strong>Address</strong>
                <br />
                <button className="btn btn-outline-red mr-lg-3 mr-sm-3  mt-5" id='UpdateBankingInfo' onClick={() => this.handleRedirect(BANKING_DETAILS)}>Banking Details</button>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(push(des))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Address);